const { Website, Account, Insights, Ems, Event, Content, Blog, Shop, Helpdesk, Godaddy, Core, Yfp, Contacts, Tracker, Stats, Webinar, Newsletter, Notification, Course, Promo, Sendible} = require('./collection')

module.exports = class AllRequest 
{
    constructor(apiDomain)
    {
        this.website = new Website(apiDomain)
        this.account = new Account(apiDomain)
        this.insights = new Insights(apiDomain)
        this.event = new Event(apiDomain)
        this.ems = new Ems(apiDomain)
        this.content = new Content(apiDomain)
        this.blog = new Blog(apiDomain)
        this.shop = new Shop(apiDomain)
        this.helpdesk = new Helpdesk(apiDomain)
        this.godaddy = new Godaddy(apiDomain)
        this.core = new Core(apiDomain)
        this.yfp = new Yfp(apiDomain)
        this.contacts = new Contacts(apiDomain)
        this.tracker = new Tracker(apiDomain)
        this.stats = new Stats(apiDomain)
        this.webinar = new Webinar(apiDomain)
        this.newsletter = new Newsletter(apiDomain)
        this.notification = new Notification(apiDomain)
        this.course = new Course(apiDomain)
        this.promo = new Promo(apiDomain)
        this.sendible = new Sendible(apiDomain)
    }
}